import { compose } from "redux";
import React, { PureComponent } from "react";
import { Route, Switch } from "react-router-dom";
import { ReportHeaderBase } from "altus-ui-components";

import ViewHeader from "features/planner/components/View/ViewHeader";
import HeliReportHeader from "features/planner/report/helicopter/components/HeliReportHeader";
import POBReportHeader from "features/planner/report/people-on-board/components/POBReportHeader";
import WorkScheduleReportHeader from "features/planner/report/workSchedule/components/WorkScheduleReportHeader";
import ScheduleOverridesReportHeader from "features/planner/report/schedule-overrides/components/ScheduleOverridesReportHeader";

class ReportHeader extends PureComponent {
  render() {
    return (
      <Switch>
        <Route exact path="/reports" component={ViewHeader} />
        <Route
          path="/reports/helicopter-booking/:groupId?"
          component={HeliReportHeader}
        />
        <Route
          path="/reports/work-schedule"
          component={WorkScheduleReportHeader}
        />
        <Route path="/reports/people-on-board" component={POBReportHeader} />
        <Route
          path="/reports/schedule-events"
          component={ScheduleOverridesReportHeader}
        />
        <Route component={ReportHeaderBase} />
      </Switch>
    );
  }
}

export default compose()(ReportHeader);
